
$(document).on('turbolinks:load',function() {
  "use strict";

  

 
  /**
   * Clients Slider
   */
  new Swiper('.clients-slider', {
    speed: 400,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      640: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });

  
  function checkArrow(section) {
 
    
    var swiperPrev = document.querySelector(`${section} .swiper-button-prev`);
    var swiperNext = document.querySelector(`${section} .swiper-button-next`);
    
    if ( window.innerWidth < 1024  ) {
      //console.log('Success', window.innerWidth);
      //swiperPrev.style.display = 'block';
      //swiperNext.style.display = 'block';
      swiperPrev.style.display = 'none';
      swiperNext.style.display = 'none';
    } else {
      //swiperPrev.style.display = 'none';
      //swiperNext.style.display = 'none';
      swiperPrev.style.display = 'block';
      swiperNext.style.display = 'block';
    }
  }

});//()